export enum NavigationWidgetComponentIds {
  topContainer = '#Navigation',
  nextIcon = '#NextIcon',
  prevIcon = '#PrevIcon',
  divider = '#divider',
  container = '#box1',
}
